import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const UpdateDocumentType = MatxLoadable({
    loader: () =>
        import ("./UpdateDocumentType")
})
const AllUpdateDocumentType= MatxLoadable({
    loader: () =>
        import ("./AllUpdateDocumentType")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const UpdateDocumentTypeRoutes = [
    {
        path: "/update_document_type",
        component: AllUpdateDocumentType,
        // settings
    },

];

export default UpdateDocumentTypeRoutes;